import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "BasketDetailHeader";
var classes = {
    button: "".concat(PREFIX, "-button"),
    title: "".concat(PREFIX, "-title"),
    actions: "".concat(PREFIX, "-actions")
};
var StyledBasketDetailHeader = styled(Box)(function (_a) {
    var _b, _c;
    var theme = _a.theme;
    return (_b = {
            borderTop: "1px solid ".concat(theme.palette.grey[300]),
            borderBottom: "1px solid ".concat(theme.palette.grey[300])
        },
        _b["& .".concat(classes.button)] = {
            textTransform: "none"
        },
        _b["& .".concat(classes.title)] = {
            display: "flex",
            justifyContent: "center"
        },
        _b["& .".concat(classes.actions)] = (_c = {
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(1),
                gap: theme.spacing(1)
            },
            _c[theme.breakpoints.down("sm")] = {
                flexDirection: "column"
            },
            _c),
        _b);
});

export { classes, StyledBasketDetailHeader as default };
//# sourceMappingURL=index.styled.js.map
